import { Group,Stack, Text } from '@ekhodealer/ekho-common/rev';

import type { LeadsTableRow } from '@ekhodealer/ekho-common';

import { DealAmountCell } from './table-cells/DealAmountCell';
import { VehicleInterestsCell } from './table-cells/VehicleInterestsCell';
import { PrequalIcon } from './PrequalIcon';
import { TypeCell } from './table-cells';

import './LeadCard.scss';

export interface LeadCardProps {
	leadData: LeadsTableRow;
	isDragging?: boolean;
}

export const LeadCard = ({ leadData, isDragging }: LeadCardProps) => {
	return (
		<div data-component='lead-card' data-is-dragging={isDragging}>
			<Stack itemsAlignY='start' itemsSpacing={12}>
				<Stack itemsAlignY='start' itemsSpacing={2}>
					<Group itemsSpacing='8' noWrap itemsAlignX='start'>
						<Text size='bodySmall' weight='semibold'>
							{leadData.name}
						</Text>
						<PrequalIcon status={leadData.preQualStatus} />
					</Group>
					<Text size='footnote' color='secondary'>
						{leadData.email}
					</Text>
					<Text size='footnote' color='secondary'>
						{leadData.phone}
					</Text>
				</Stack>
				<Stack itemsSpacing={2}>
					<VehicleInterestsCell vehicleInterests={leadData.vehicleInterests} />
					<DealAmountCell dealAmount={leadData.dealAmount} />
				</Stack>
				<TypeCell type={leadData.type} />
			</Stack>
		</div>
	);
};
